import { Grid } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { GridItem } from "Components/Shared/GridItem";
import type { HunterDetailPartyDto } from "Infrastructure/Api/Api";
import { PaperTitle } from "Components/Shared/PaperTitle";

const RESOURCES = Resources.Hunter.HuntersOverview.Detail;
const COMMON_RESOURCES = Resources.Common;

type Props = {
  party: HunterDetailPartyDto;
};

export const PartyInfoSection = ({
  party: { type, companyName, companyNumber, firstName, lastName, taxNumber },
}: Props) => {
  const { t } = useResource();

  return (
    <>
      <PaperTitle>{t(RESOURCES.PartyInfo)}</PaperTitle>
      <Grid container spacing={2}>
        <GridItem
          label={t(RESOURCES.PartyType)}
          value={t(COMMON_RESOURCES.PartyType[type])}
        />
        <GridItem label={t(RESOURCES.CompanyName)} value={companyName} />
        <GridItem label={t(RESOURCES.CompanyNumber)} value={companyNumber} />
        <GridItem label={t(RESOURCES.FirstName)} value={firstName} />
        <GridItem label={t(RESOURCES.LastName)} value={lastName} />
        <GridItem label={t(RESOURCES.TaxNumber)} value={taxNumber} />
      </Grid>
    </>
  );
};
